import { instance } from "api/apiBase";

interface ApartmentsComStatusResponse {
  connected: boolean;
}

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/apartments_com";

export const apartmentsComApi = {
  getStatus: async (): Promise<ApartmentsComStatusResponse> => {
    const { data } =
      await instance.get<ApartmentsComStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (): Promise<ApartmentsComStatusResponse> => {
    const { data } =
      await instance.post<ApartmentsComStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  disconnect: async (): Promise<ApartmentsComStatusResponse> => {
    const { data } =
      await instance.delete<ApartmentsComStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  }
};
